import { styled, Typography } from '@mui/material'

export const ClampedParagraph = styled(Typography)(({ maxLines }: { maxLines: number }) => ({
  display: '-webkit-box',
  '-webkit-line-clamp': maxLines + '',
  '-webkit-box-orient': 'vertical',
  overflow: 'hidden',
}))
